export const BASE_URL = "https://primax-rwanda.com/api";
//export const BASE_URL = 'http://localhost:4000/api';